import React, {
    useEffect,
    useRef,
    useState,
} from 'react'
import {
    database,
    listenData,
} from '../components/shared/database';
import Modal from '../components/shared/modal';
import classnames from 'classnames';
import { generateUUID } from '../components/shared/uuid-generator';
import { processQuerySnapshot } from '../components/shared/process-query-snapshot';

export const ScannerModal = () => {
    const [scannerData, setScannerData] = useState([])

    const [foodName, setFoodName] = useState('')
    const [expireDate, setExpireDate] = useState('')
    const [countItems, setCountItems] = useState(1)

    const calendarRef = useRef()

    useEffect(() => {
        listenData('scanner', data => {
            setScannerData(data)

            if (data?.length > 0) {
                setFoodName(data?.[0]?.lastScanName)
            }
        })


    }, []);

    useEffect(() => {
        if (calendarRef.current) {
            jQuery('#calendar')
                .datepicker({
                    language: "cs",
                    calendarWeeks: true,
                    todayHighlight: true
                })
                .on('changeDate', function(event) {
                    setExpireDate(event.format())
                })
        }
    }, [calendarRef?.current])

    // Funkce pro přidání čísla do vybraného data
    const handleButtonClick = (value) => {
        setExpireDate((prevDate) => {
            if (prevDate.length === 2 || prevDate.length === 5) {
                return prevDate + '.' + value;
            }
            return prevDate + value;
        });
    };

    // Funkce pro vymazání posledního znaku v date
    const handleBackspace = () => setExpireDate((prevDate) => prevDate.slice(0, -1));

    const saveForm = async () => {
        const fridgeUid = generateUUID()
        const foodRandomUid = generateUUID()

        const food = await database('fridge')
            .where('ean', '==', scannerData?.[0]?.lastScanEan)
            .get()
            .then(processQuerySnapshot)
            .then(data => data?.[0])

        if (!food) {
            await database('food')
                .doc(foodRandomUid)
                .set({
                    description: '',
                    name: foodName,
                    ean: scannerData?.[0]?.lastScanEan,
                    uid: foodRandomUid,
                })
        }

        const expireMoment = window.moment(expireDate, 'DD.MM.YYYY')

        await database('fridge')
            .doc(fridgeUid)
            .set({
                uid: fridgeUid,
                uidFood: food?.uid || foodRandomUid,
                name: foodName,
                description: '',
                dateTo: expireMoment.format('L'),
                dateToTimestamp: expireMoment.format('x'),
                buyAt: window.moment().format('L'),
                countFood: countItems,
            })

        await database('scanner')
            .doc(scannerData?.[0]?.uid)
            .delete()

        setScannerData(null)
    }

    const removeForm = async () => {
        await database('scanner')
            .doc(scannerData?.[0]?.uid)
            .delete()

        setScannerData(null)
    }

    // Hardcode styles, because my tablet don't want transform and load it in sass...
    const hardcodeStyles = () => (
        <style>
            {`
            .scanner-modal .count-buttons-container {
                display: flex;
                align-items: center;
                flex-direction: row;
            }
            .scanner-modal .count-button {
                width: 30px;
                height: 30px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: #dedede;
                margin-right: 5px;
            }
            .scanner-modal .count-button.active {
                background: #2ab27b;
            }
            .scanner-modal .expire-keyboard {
                display: flex;
                align-items: center;
                flex-direction: column;
            }
            .scanner-modal .expire-keyboard .keyboard-row {
                display: flex;
                align-items: center;
                flex-direction: row;
            }
            .scanner-modal .expire-keyboard .keyboard-button {
                width: 50px;
                height: 50px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: #dedede;
                margin: 3px;
            }
            .scanner-modal .expire-keyboard .keyboard-button.double-width {
                width: 100px;
            }
            `}
        </style>
    )

    if (!scannerData || scannerData?.length === 0) {
        return null
    }

    return (
        <Modal
            description={scannerData?.[0]?.lastScanEan}
            handleHideModal={() => setScannerData(null)}
            content={() => (
                <>
                    {hardcodeStyles()}
                    <div className="p-3 scanner-modal">
                        <div className="mb-3">
                            <input
                                className="form-control"
                                type="text"
                                value={foodName}
                                onChange={event => setFoodName(event.target.value)}
                            />
                        </div>

                        <div className="count-buttons-container mb-3">
                            <div className="mr-2">
                                Počet:
                            </div>

                            {Array.from({ length: 10 }, (_, i) => i + 1).map(countNumber => (
                                <div
                                    className={classnames({
                                        'count-button': true,
                                        'active': countItems === countNumber,
                                    })}
                                    onClick={() => setCountItems(countNumber)}
                                >
                                    {countNumber}
                                </div>
                            ))}
                        </div>

                        <div className="mb-3">
                            <div className="mb-3">
                                <label htmlFor="expire-date" className="form-label">
                                    Spotřebovat do:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="expire-date"
                                    value={expireDate}
                                    onChange={event => setExpireDate(event.target.value)}
                                />
                            </div>

                            <div
                                id="calendar"
                                ref={calendarRef}
                                className="d-flex align-items-center justify-content-center"
                            />


                            {/*<div className="expire-keyboard">*/}
                            {/*    <div className="keyboard-row">*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('7')}>7</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('8')}>8</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('9')}>9</div>*/}
                            {/*    </div>*/}
                            {/*    <div className="keyboard-row">*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('4')}>4</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('5')}>5</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('6')}>6</div>*/}
                            {/*    </div>*/}
                            {/*    <div className="keyboard-row">*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('1')}>1</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('2')}>2</div>*/}
                            {/*        <div className="keyboard-button" onClick={() => handleButtonClick('3')}>3</div>*/}
                            {/*    </div>*/}
                            {/*    <div className="keyboard-row">*/}
                            {/*        <div className="keyboard-button" onClick={() => handleBackspace()}>{'<'}</div>*/}
                            {/*        <div className="keyboard-button double-width"*/}
                            {/*             onClick={() => handleButtonClick('0')}>0*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="btn btn-danger" onClick={removeForm}>Smazat sken</div>
                            <div className="btn btn-success" onClick={saveForm}>Uložit</div>
                        </div>
                    </div>
                </>
            )}
            dialogClass="modal-lg"
        />
    )
}
